import { render, staticRenderFns } from "./ShowAnswer.vue?vue&type=template&id=18e52ba1&"
import script from "./ShowAnswer.vue?vue&type=script&lang=js&"
export * from "./ShowAnswer.vue?vue&type=script&lang=js&"
import style0 from "./ShowAnswer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports